const GROUPVIEW = {
  listGroups: "Group list",
  newGroup: "New group",

  name: "Name",
  description: "Description",
  company: "Company",
  state: "State",
  actions: "Actions",

  emptyGroups: "There are no registered groups.",
  groups: "Groups",

  acept: "Accept",
  cancel: "Cancel",

  DIALOGS: {
    titleDelete: `Delete Group: {description}`,
    textDelete: `This option cannot be undone, are you sure?`
  },

  NOTIFY: {
    titleDeleteGorup: `Delete groups`,
    NotAutorization: `You do not have permissions to perform this action.`,
    error: `An error occurred while deleting the group`,
    goups: "Groups",
    ActionUnavaliable: "Action not available at the moment"
  },

  remember: "Remember not to use <strong>special characters</strong>.",
  name: "Name",
  save: "Save",
  clean: "Clean"
};

export default { GROUPVIEW };
